import { useMQTT } from 'mqtt-vue-hook'
import {SubscribeOptions} from "mqtt-vue-hook/dist/base-hook";
const mqttHook = useMQTT()

export default async function initMqtt() {
    //`ws://103.189.234.55:8083/mqtt`

    const protocol = 'ws'
    const host = 'ismaillowkey1.my.id'
    const port = '8083'
    const url = `${protocol}://${host}:${port}/mqtt`

    // const protocol = 'ws'
    // const host = window.location.host
    // const ipWort = host.split(':')
    // const ip = ipWort[0]
    // const port = '8083'
    // const url = `${protocol}://${ip}:${port}/mqtt`

    await mqttHook.connect(url, {
        clean: false,
        keepalive: 60,
        clientId: `ibad_${Math.random().toString(16).substring(2, 10)}`,
        connectTimeout: 4000,
        reconnectPeriod: 1000
    })
}